/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Advantage
 */
export interface Advantage {
    /**
     * 
     * @type {object}
     * @memberof Advantage
     */
    gradient?: object;
    /**
     * 
     * @type {string}
     * @memberof Advantage
     */
    readonly name?: string;
    /**
     * 
     * @type {string}
     * @memberof Advantage
     */
    readonly description?: string;
    /**
     * 
     * @type {string}
     * @memberof Advantage
     */
    readonly image?: string;
    /**
     * 
     * @type {string}
     * @memberof Advantage
     */
    icon?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Advantage
     */
    background?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Advantage
     */
    readonly sort?: number;
}

export function AdvantageFromJSON(json: any): Advantage {
    return AdvantageFromJSONTyped(json, false);
}

export function AdvantageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Advantage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'gradient': !exists(json, 'gradient') ? undefined : json['gradient'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'image': !exists(json, 'image') ? undefined : json['image'],
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'background': !exists(json, 'background') ? undefined : json['background'],
        'sort': !exists(json, 'sort') ? undefined : json['sort'],
    };
}

export function AdvantageToJSON(value?: Advantage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'gradient': value.gradient,
        'icon': value.icon,
        'background': value.background,
    };
}


